module.exports = __webpack_public_path__ + "media/images/subscription_ad_2-a641cd74950b8e9993e0b0a81d1e9cd7.png";